import { clearGameGlsPayload } from '@/game-client/game-gls-payload';
import { clearGlsResponseJackpotMode } from '@/game-client/gls-jackpot-mode-tracker';

let launchEpoch = 0;
let launchInFlight = false;
/** Survives game store reset; used to restore handshakeLaunchEpoch after launch-new-game UI reset. */
let recordedHandshakeLaunchEpoch: number | null = null;

const glsLaunchInvalidateListeners = new Set<() => void>();

/** Register cleanup when {@link invalidateGlsLaunch} abandons the current launch. */
export const registerGlsLaunchInvalidateListener = (
  listener: () => void,
): (() => void) => {
  glsLaunchInvalidateListeners.add(listener);
  return () => {
    glsLaunchInvalidateListeners.delete(listener);
  };
};

export const recordHandshakeLaunchEpoch = (epoch: number): void => {
  recordedHandshakeLaunchEpoch = epoch;
};

export const getRecordedHandshakeLaunchEpoch = (): number | null =>
  recordedHandshakeLaunchEpoch;

/** Drop any in-flight GLS response before a soft reload / store reset. */
export const invalidateGlsLaunch = (): void => {
  launchEpoch += 1;
  launchInFlight = false;
  recordedHandshakeLaunchEpoch = null;
  clearGameGlsPayload();
  clearGlsResponseJackpotMode();
  glsLaunchInvalidateListeners.forEach((listener) => {
    listener();
  });
};

export const tryBeginGlsLaunch = (): number | null => {
  if (launchInFlight) {
    return null;
  }

  launchInFlight = true;
  return launchEpoch;
};

export const isGlsLaunchGenerationCurrent = (generation: number): boolean =>
  generation === launchEpoch;

export const getGlsLaunchGeneration = (): number => launchEpoch;

export const releaseGlsLaunch = (generation: number): void => {
  if (isGlsLaunchGenerationCurrent(generation)) {
    launchInFlight = false;
  }
};

/** @internal test helper */
export const resetGlsLaunchGuardForTests = (): void => {
  launchEpoch = 0;
  launchInFlight = false;
  recordedHandshakeLaunchEpoch = null;
};
